import { getLocalStorageValue } from "./localStoreManager";
const baseUrl = process.env.REACT_APP_API_URL;

const fetchNoToken = (endpoint, data, method = "GET") => {
  const url = `${baseUrl}/${endpoint}`;

  if (method === "GET") {
    return fetch(url);
  }
  const options = {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  };

  return fetch(url, options);
};

const fetchWithToken = (endpoint, data, method = "GET") => {
  const url = `${baseUrl}/${endpoint}`;
  const token = getLocalStorageValue("localStorageAuth.jwt_token") || "";
  const auth = "Bearer " + token;
  const options = {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: auth,
    },
  };
  if (method !== "GET") {
    options["body"] = JSON.stringify(data);
  }

  return fetch(url, options);
};

const fetchFileWithToken = (endpoint, data, method = "GET") => {
  const url = `${baseUrl}/${endpoint}`;
  const token = getLocalStorageValue("localStorageAuth.jwt_token") || "";
  const auth = "Bearer " + token;
  console.log("upload file....asd");
  const options = {
    method: method,
    headers: {
      Accept: "application/json",
      Authorization: auth,
    },
  };
  if (method !== "GET") {
    options["body"] = data;
  }
  console.log("before....");
  return fetch(url, options);
};

export { fetchNoToken, fetchWithToken, fetchFileWithToken };
